import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import fields from '../../lib/fields';

import FormFieldsCompact from '../form/fieldsCompact';

const JOURNAL_ITEMS_FIELDS = [
    'journalItems.generalCondition',
    'journalItems.physicalExaminationFindings',
    'journalItems.diagnosticTests',
    'journalItems.diagnosis',
    'journalItems.treatmentPlan',
    'journalItems.medicines',
    'journalItems.medicine',
    'journalItems.diagnoses',
    'journalItems.description',
    'journalItems.clientCommunication',
    'journalItems.recommendations',
    'journalItems.followUp',
    'journalItems.puls',
    'journalItems.respiration',
    'journalItems.temperature',
];

@observer
class JournalSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('customer', ['journalSettings']),
        };
    }

    onInputCallback = (id, name, value) => {
        const { userStore } = this.props.stores;
        const { customer } = userStore;
        // Sync changes back to userStore.customer so the journal form
        // immediately reflects visibility changes.
        const parts = name.split('.');
        if (parts.length === 2 && parts[0] === 'journalItems') {
            const updatedJournalItems = { ...(customer.journalItems || {}), [parts[1]]: value };
            userStore.updateObjectKeyValue('customer', 'journalItems', updatedJournalItems);
        }
    }

    componentDidMount() {
        const { customerStore, userStore } = this.props.stores;
        const { customer: userCustomer } = userStore;
        customerStore.updateKeyValue('customer', userCustomer);
    }

    render() {
        const { sections } = this.state;
        const { drawerLevel } = this.props;
        const { customerStore } = this.props.stores;

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        <i class='fa-solid fa-gear me-2' />
                        <Text id='dyrejournal.journal-settings.title'>Journal Settings</Text>
                    </div>
                    <div class='d-flex flex-column justify-content-start h-100' style='padding: 0 8px;'>
                        <FormFieldsCompact
                            stores={this.props.stores}
                            sections={sections}
                            holdingStore={customerStore}
                            objectName='customer'
                            isNew={false}
                            drawerLevel={drawerLevel}
                            hideAdmin={true}
                            fields={JOURNAL_ITEMS_FIELDS}
                            onInputcallback={this.onInputCallback}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default JournalSettings;
